import React from "react";
import TabHub from "@/components/TabHub";
import Benefits from "@/pages/Benefits";
import OrderID from "@/pages/OrderID";

export default function MembershipHub() {
  return (
    <TabHub
      testid="membership-hub"
      eyebrow="Membership"
      title="Your benefits and your Membership ID."
      subtitle="See what membership in the Trust confers, then claim your instant digital ID or order an embossed physical card."
      tabs={[
        { key: "benefits", label: "Member Benefits", component: <Benefits embedded /> },
        { key: "order", label: "Order Membership ID", component: <OrderID embedded /> },
      ]}
    />
  );
}
